import { render } from "./textlink.vue?vue&type=template&id=28068759&scoped=true&ts=true"
import script from "./textlink.vue?vue&type=script&lang=ts"
export * from "./textlink.vue?vue&type=script&lang=ts"

import "./textlink.vue?vue&type=style&index=0&id=28068759&scoped=true&lang=less"

import exportComponent from "/home/runner/work/vue3-admin/vue3-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28068759"]])

export default __exports__